import React from "react";
import "../../Styles/certified/mobolutions.css";

export default function Finzly() {
  return (
    <>
      <div className="mobolutions-certified-details-section">
        <div className="mobolutions-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="mobolutions-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="mobolutions-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="mobolutions-certified-badge"
            />
            <div className="mobolutions-certified-company-names">
              <a href="https://www.mobolutions.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/mobolution/mob.png"
                alt="Walkzero Logo"
                className="mobolutions-certified-company-logo"
              />
            </a>
              <h1 className="mobolutions-certified-full-name">
              Mobolution India Pvt Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="mobolutions-certified-details-right">
            <img
              src="/assets/mobolution/mob_3.jpeg"
              alt="Finzly Office"
              className="mobolutions-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="mobolutions-certified-description">
          <h2>
            Why  Mobolution India Pvt Ltd is an Outstanding Workplaces
          </h2>
          <p>
            We are a Monetization Transformation Partner helping enterprises reimagine how they create, capture, and grow revenue. Our singular focus is monetization complexity, spanning every industry and use case. Through industry-specific accelerators, Telco-in-a-Box, High-Tech-in-a-Box, and Tolling-in-a-Box, we deliver pre-configured, production-ready monetization platforms tailored to each vertical. As a certified SAP partner, we harness SAP BRIM to power these transformations at enterprise scale. From defining new revenue models to billing, collections, and recognition, we reshape revenue end-to-end, making us a true strategic partner for CFOs and business leaders.


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="mobolutions-certified-info-cards">
          <div className="mobolutions-certified-info-card">
            <div className="mobolutions-certified-info-title">COMPANY SIZE</div>
            <div className="mobolutions-certified-info-value">140 Employees</div>
          </div>
          <div className="mobolutions-certified-info-card">
            <div className="mobolutions-certified-info-title">INDUSTRY</div>
            <div className="mobolutions-certified-info-value">IT Services & Consulting


</div>
          </div>
          <div className="mobolutions-certified-info-card">
            <div className="mobolutions-certified-info-title">CONNECT</div>
            <div className="mobolutions-certified-info-icons">
              <span className="mobolutions-certified-icon-round">
                <a href="https://www.mobolutions.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="mobolutions-certified-icon-round">
                <a href="https://www.linkedin.com/company/mobolutions/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="mobolutions-certified-icon-round">
                <a href="https://www.facebook.com/mobolutions/videos/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="mobolutions-certified-info-card">
            <div className="mobolutions-certified-info-title">LOCATION (HQ)</div>
            <div className="mobolutions-certified-info-value">Plano, Texas</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="mobolutions-certified-recognition-section">
          <h2 className="mobolutions-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="mobolutions-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="mobolutions-certified-recognition-image"
            />
          </div>
          <div className="mobolutions-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="mobolutions-certified-life-section">
          <h2 className="mobolutions-certified-life-title">
            Life at Mobolution India Pvt Ltd
          </h2>
          <div className="mobolutions-certified-life-gallery">
            <div className="mobolutions-certified-life-col">
              <img src="/assets/mobolution/mob_1.jpeg" alt="Office 1" className="mobolutions-certified-life-img" />
              <img src="/assets/mobolution/mob_2.jpeg" alt="Team 1" className="mobolutions-certified-life-img" />
            </div>
            <div className="icom-certified-life-col mobolutions-certified-life-center">
              <img src="/assets/mobolution/mob_5.jpeg" alt="Main Office" className="mobolutions-certified-life-img mobolutions-certified-life-img-large" />
            </div>
            <div className="mobolutions-certified-life-col">
              <img src="/assets/mobolution/mob_3.jpeg" alt="Office 2" className="mobolutions-certified-life-img" />
              <img src="/assets/mobolution/mob_4.jpeg" alt="Team 2" className="mobolutions-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
